import { closeAllEpisodes } from "./episode";
import { flushOnUnload } from "./queue";
import { endSessionOnLeave, initSession } from "./session";

let initialized = false;

// Startup: recover any session a tab abandoned without emitting its end, then resume/mint this
// tab's own session. Runs before the leave handlers so the session exists to be ended on leave.
export const initImpressions = (): void => {
  if (initialized || typeof document === "undefined") return;
  initialized = true;

  initSession();

  const onLeave = (): void => {
    closeAllEpisodes("unmount");
    endSessionOnLeave(Date.now());
    flushOnUnload();
  };

  // On tab hide / page unload (leave the tab — impressions AC-W6 + sessions AC-W1): close open
  // episodes so the last-seen item is
  // captured, emit this tab's session_end at the leave moment, then fire the one keepalive attempt
  // (survives unload) carrying both. The session isn't torn down — a return within the idle gap
  // continues it and re-emits the same deterministic end, latest ingested winning.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") onLeave();
  });
  window.addEventListener("pagehide", () => onLeave());
};
